import { createSelector } from 'reselect';

const getValue = ({ value }) => value;

export const getAllAltitudes = createSelector(
    ({ altitudes }) => altitudes,
    (altitudes) => altitudes.all,
);

export const getAllAltitudeValues = createSelector(
    getAllAltitudes,
    (altitudes) => altitudes.map(getValue),
);

export const getAltitudeMinYear = createSelector(
    getAllAltitudes,
    (altitudes) => altitudes[0].year,
);

export const getAltitudeMaxYear = createSelector(
    getAllAltitudes,
    (altitudes) => altitudes[altitudes.length - 1].year,
);

export default undefined;
